import { useState, useEffect } from "react";

export default function DesignGraphiqueLandingPage() {
  const headingStyle = { fontFamily: "'Tajawal', sans-serif" };
  const bodyStyle = { fontFamily: "'Cairo', sans-serif" };
  const [submitMsg, setSubmitMsg] = useState("");
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowScroll(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const months = [
    {
      title: "المحور 01", subtitle: "أساسيات التصميم والطباعة",
      items: [
        "مبادئ التصميم الجرافيكي الاحترافي",
        "السلسلة الطباعية (La chaîne graphique)",
        "أنماط الألوان في التصميم (Les modes des couleurs)",
        "أساسيات الطباعة والخطوط (Typographie)",
      ]
    },
    {
      title: "المحور 02", subtitle: "Illustrator (تطبيقي)",
      items: [
        "تصميم شعار احترافي (Logo Design)",
        "تصميم بطاقة أعمال (Carte de visite)",
        "تصميم منشور إعلاني (Flyer)",
        "تصميم ملصق إعلاني (Affiche publicitaire)",
        "تصميم مطوية (Dépliant)",
      ]
    },
    {
      title: "المحور 03", subtitle: "Photoshop (تطبيقي مكثف)",
      items: [
        "معالجة وتعديل الصور (Traitement et retouche)",
        "تغيير الألوان والإضاءة (Couleurs et lumières)",
        "تصميم إعلانات احترافية",
        "الدمج الفني للصور (Photomontage / Manipulation)",
      ]
    },
    {
      title: "المحور 04", subtitle: "Lightroom — معالجة احترافية",
      items: [
        "Retouche photo professionnelle (Before / After)",
        "Correction colorimétrique avancée",
        "Création de presets personnalisés",
        "Export optimisé (Web / Impression)",
      ]
    },
    {
      title: "المحور 05", subtitle: "Montage Vidéo (عملي 100%)",
      items: [
        "تقطيع وتركيب الفيديو (Découpage et assemblage)",
        "إضافة المؤثرات البصرية (Effets visuels)",
        "إدراج النصوص والعناوين (Titres et animations)",
        "تصحيح الألوان (Color Grading)",
        "تحسين الصوت (Audio editing)",
      ]
    },
    {
      title: "المحور 06", subtitle: "InDesign (تطبيقي)",
      items: [
        "تصميم الصفحات والتخطيط (Mise en page)",
        "إدارة النصوص والفقرات",
        "إنشاء الجداول (Création des tableaux)",
        "إعداد الملفات للطباعة (PDF Print + Bleed)",
        "تصدير الكتب الرقمية (EPUB)",
      ]
    },
  ];

  const tools = [
    "Illustrator CC", "Photoshop CC", "InDesign CC",
    "Lightroom CC", "Montage Vidéo",
  ];

  const handleLeadSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const fullName = formData.get("fullName") || "";
    const phone = formData.get("phone") || "";
    const contactMethod = formData.get("contactMethod") || "";

    const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwvDq8RET3l14lDdyenLZgn9938vzMYgHuh1MXaZQnlN5JFhDa8d5vdd-7z3_0y8jM/exec";

    setSubmitMsg("⏳ جاري الإرسال...");

    try {
      await fetch(SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nom: fullName, telephone: phone, contact: contactMethod, formation: "Design Graphique & Montage Vidéo" }),
      });

      event.target.reset();
      setSubmitMsg("🎉 تم تسجيلك بنجاح! مرحبًا بك في Big Academy، سنرافقك في رحلتك الإبداعية.");
      setTimeout(() => setSubmitMsg(""), 5000);
    } catch {
      setSubmitMsg("❌ حدث خطأ، حاول مرة أخرى");
      setTimeout(() => setSubmitMsg(""), 4000);
    }
  };

  // SEO - Update document head
  useEffect(() => {
    document.title = "BIG ACADEMY أكادير | تكوين في التصميم الجرافيكي والمونتاج الفيديو";
    const setMeta = (name, content, prop) => {
      let el = document.querySelector(prop ? `meta[property="${name}"]` : `meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); prop ? el.setAttribute("property", name) : el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("description", "BIG ACADEMY — معهد متخصص في التكوين في التصميم الجرافيكي والمونتاج الفيديو بأكادير. برنامج حضوري 6 أشهر يشمل Photoshop, Illustrator, Premiere Pro, After Effects وأكثر. سجل الآن!");
    setMeta("keywords", "تصميم جرافيكي أكادير, مونتاج فيديو المغرب, Photoshop, Illustrator, Premiere Pro, After Effects, تكوين مهني أكادير, Big Academy, دورات تصميم");
    setMeta("robots", "index, follow");
    setMeta("author", "BIG ACADEMY");
    setMeta("og:title", "BIG ACADEMY | تكوين في التصميم الجرافيكي والمونتاج الفيديو", true);
    setMeta("og:description", "برنامج تكوين احترافي 6 أشهر في التصميم الجرافيكي والمونتاج بأكادير. سجل الآن!", true);
    setMeta("og:type", "website", true);
    setMeta("og:url", "https://design.institutbigacademy.com", true);
    setMeta("og:locale", "ar_MA", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", "BIG ACADEMY | تكوين في التصميم الجرافيكي");
    setMeta("twitter:description", "برنامج تكوين احترافي 6 أشهر بأكادير في التصميم الجرافيكي والمونتاج الفيديو");
    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) { canonical = document.createElement("link"); canonical.setAttribute("rel", "canonical"); document.head.appendChild(canonical); }
    canonical.setAttribute("href", "https://design.institutbigacademy.com");
    document.documentElement.setAttribute("lang", "ar");
    document.documentElement.setAttribute("dir", "rtl");
  }, []);

  return (
    <>
      {/* Structured Data */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "EducationalOrganization",
        "name": "BIG ACADEMY",
        "description": "معهد متخصص في التكوين في التصميم الجرافيكي والمونتاج الفيديو بأكادير، المغرب",
        "url": "https://design.institutbigacademy.com",
        "telephone": "+212606161663",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "حي السلام، زنقة المعدر، إقامة باب السلام، الطابق الأول",
          "addressLocality": "أكادير",
          "addressCountry": "MA"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "30.402446940180177",
          "longitude": "-9.549635455163388"
        },
        "sameAs": ["https://wa.me/212606161663"],
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "برامج التكوين",
          "itemListElement": [
            {"@type": "Offer", "itemOffered": {"@type": "Course", "name": "التصميم الجرافيكي والمونتاج الفيديو", "description": "برنامج تكوين احترافي 6 أشهر"}},
          ]
        }
      })}} />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700;800&family=Tajawal:wght@400;700;800;900&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        :root{
          --red:#c1121f;--red-dark:#7b0d14;
          --gold:#f5a623;--gold-light:#ffd166;
          --bg:#060606;--surface:rgba(255,255,255,0.04);
          --border:rgba(255,255,255,0.09);
          --text:#f0f0f0;--muted:rgba(240,240,240,0.55);
        }
        html{scroll-behavior:smooth}
        @keyframes fadeUp{from{opacity:0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}
        @keyframes glowPulse{0%,100%{opacity:.6;transform:scale(1)}50%{opacity:1;transform:scale(1.08)}}
        @keyframes ticker{from{transform:translateX(0)}to{transform:translateX(-50%)}}
        .au{animation:fadeUp .7s ease both}
        .d1{animation-delay:.1s}.d2{animation-delay:.22s}.d3{animation-delay:.34s}.d4{animation-delay:.46s}.d5{animation-delay:.58s}
        .page{direction:rtl;min-height:100vh;background:var(--bg);overflow-x:hidden;position:relative;font-family:'Cairo',sans-serif;color:var(--text)}
        .page::before{content:'';position:fixed;inset:0;background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='1'/%3E%3C/svg%3E");opacity:.025;pointer-events:none;z-index:0}

        /* NAV */
        .nav{position:fixed;top:0;left:0;right:0;z-index:100;backdrop-filter:blur(18px);-webkit-backdrop-filter:blur(18px);background:rgba(6,6,6,.92);border-bottom:1px solid rgba(245,158,11,.25);padding-top:env(safe-area-inset-top);box-shadow:0 4px 24px rgba(0,0,0,.6),0 6px 40px rgba(245,158,11,.15),0 1px 0 rgba(245,158,11,.2)}
        .page{padding-top:72px}
        .nav-i{max-width:1200px;margin:0 auto;padding:0 28px;height:72px;display:flex;align-items:center;justify-content:space-between;gap:20px}
        .logo{display:flex;align-items:center;gap:14px}
        .logo-b{width:46px;height:46px;border-radius:14px;background:linear-gradient(135deg,var(--red),var(--gold));display:flex;align-items:center;justify-content:center;font-weight:900;font-size:14px;color:#000;flex-shrink:0;box-shadow:0 0 18px rgba(193,18,31,.45)}
        .logo-n{font-size:18px;font-weight:900}
        .logo-s{font-size:11px;color:#f5a623;margin-top:1px;font-weight:600}
        .nav-links{display:flex;gap:28px;list-style:none}
        .nav-links a{font-size:13px;color:#f59e0b;text-decoration:none;transition:color .2s,text-shadow .2s;font-weight:600}
        .nav-links a:hover{color:#22c55e;text-shadow:0 0 12px rgba(34,197,94,.6)}
        .nav-cta{background:linear-gradient(135deg,#f59e0b,#ef4444);color:#000;font-weight:800;font-size:13px;padding:10px 22px;border-radius:50px;text-decoration:none;box-shadow:0 4px 20px rgba(245,158,11,.4);transition:transform .2s,box-shadow .2s,background .3s;white-space:nowrap}
        .nav-cta:hover{transform:translateY(-2px);background:linear-gradient(135deg,#16a34a,#22c55e);box-shadow:0 8px 28px rgba(34,197,94,.6);color:#fff}

        /* HERO */
        .hero-wrap{position:relative;overflow:hidden}
        .glow-tr{position:absolute;top:-80px;right:-120px;width:480px;height:480px;border-radius:50%;background:radial-gradient(circle,rgba(193,18,31,.22) 0%,transparent 70%);animation:glowPulse 5s ease infinite;pointer-events:none}
        .glow-bl{position:absolute;bottom:0;left:-100px;width:360px;height:360px;border-radius:50%;background:radial-gradient(circle,rgba(245,166,35,.14) 0%,transparent 70%);animation:glowPulse 7s ease infinite 1.5s;pointer-events:none}
        .hero{position:relative;max-width:1200px;margin:0 auto;padding:80px 28px 100px;display:grid;grid-template-columns:1fr 1fr;gap:60px;align-items:center}
        .eyebrow{display:inline-flex;align-items:center;gap:8px;background:rgba(45,212,191,.1);border:1px solid rgba(45,212,191,.35);border-radius:50px;padding:8px 20px;font-size:15px;color:#2dd4bf;margin-bottom:22px;letter-spacing:.5px;font-weight:700}
        .eyebrow::before{content:'✦';font-size:11px}
        .h1{font-size:clamp(36px,4.5vw,58px);font-weight:900;line-height:1.18;letter-spacing:-.5px}
        .h1 .red{color:var(--red)}.h1 .gold{color:var(--gold)}
        .hero-p{margin-top:22px;font-size:16px;line-height:1.8;color:var(--muted);max-width:520px}
        .actions{display:flex;flex-wrap:wrap;gap:14px;margin-top:36px}
        .btn-p{background:linear-gradient(135deg,var(--gold),#e08c0e);color:#000;font-weight:800;font-size:14px;padding:14px 28px;border-radius:16px;text-decoration:none;box-shadow:0 6px 28px rgba(245,166,35,.35);transition:transform .2s,box-shadow .2s}
        .btn-p:hover{transform:translateY(-3px);box-shadow:0 12px 36px rgba(245,166,35,.5)}
        .btn-g{background:var(--surface);border:1px solid var(--border);color:var(--text);font-weight:700;font-size:14px;padding:14px 28px;border-radius:16px;text-decoration:none;transition:background .2s,border-color .2s}
        .btn-g:hover{background:rgba(255,255,255,.08);border-color:rgba(255,255,255,.2)}
        .feats{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:32px}
        .feat{background:var(--surface);border:1px solid var(--border);border-radius:14px;padding:12px 16px;font-size:13px;color:rgba(240,240,240,.8);display:flex;align-items:center;gap:8px}
        .feat::before{content:'◆';color:var(--gold);font-size:8px;flex-shrink:0}

        /* HERO CARD */
        .hcard{background:rgba(12,12,12,.9);border:1px solid rgba(255,255,255,.1);border-radius:28px;padding:20px;backdrop-filter:blur(20px);box-shadow:0 30px 80px rgba(0,0,0,.5);position:relative}
        .hcard::before{content:'';position:absolute;inset:-1px;border-radius:28px;background:linear-gradient(135deg,rgba(193,18,31,.3),transparent 50%,rgba(245,166,35,.2));z-index:-1}
        .ch{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:22px}
        .cbadge{background:linear-gradient(135deg,var(--red),var(--gold));color:#000;font-weight:900;font-size:13px;padding:8px 16px;border-radius:12px}
        .ct{font-size:22px;font-weight:900;line-height:1.3}
        .cs{font-size:12px;color:var(--muted);margin-top:3px}
        .cstats{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:18px}
        .sb{border-radius:18px;padding:18px}
        .sb.r{background:linear-gradient(135deg,rgba(193,18,31,.25),rgba(100,10,18,.1))}
        .sb.g{background:linear-gradient(135deg,rgba(245,166,35,.2),rgba(120,80,0,.1))}
        .sn{font-size:32px;font-weight:900;line-height:1}
        .sl{font-size:12px;color:var(--muted);margin-top:6px}
        .tgrid{background:rgba(255,255,255,.03);border:1px solid var(--border);border-radius:18px;padding:16px}
        .tl{font-size:12px;font-weight:700;margin-bottom:12px;letter-spacing:.8px;background:linear-gradient(90deg,#f59e0b,#2dd4bf);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
        .tlist{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}
        .tchip{background:rgba(255,255,255,.05);border:1px solid var(--border);border-radius:10px;padding:8px 6px;text-align:center;font-size:11px;color:#ffffff;font-weight:600;transition:background .2s,border-color .2s}
        .tchip:hover{background:rgba(245,166,35,.1);border-color:rgba(245,166,35,.3)}

        /* TICKER */
        .ticker{border-top:1px solid var(--border);border-bottom:1px solid var(--border);background:rgba(193,18,31,.06);overflow:hidden;padding:14px 0}
        .ttrack{display:flex;width:max-content;animation:ticker 28s linear infinite}
        .titem{display:flex;align-items:center;gap:14px;padding:0 28px;font-size:13px;color:var(--muted);white-space:nowrap}
        .tdot{width:5px;height:5px;border-radius:50%;background:var(--gold);flex-shrink:0}

        /* STATS ROW */
        .stats-row{max-width:1200px;margin:60px auto;padding:0 28px}
        .sgrid{display:grid;grid-template-columns:repeat(4,1fr);gap:16px}
        .scell{border:1px solid var(--border);border-radius:24px;padding:28px 20px;text-align:center;transition:transform .25s,box-shadow .25s;position:relative;overflow:hidden;margin:4px}
        .scell:hover{transform:translateY(-5px);box-shadow:0 20px 50px rgba(0,0,0,.4)}
        .scell-icon{font-size:28px;margin-bottom:12px;display:block}
        .snum{font-size:24px;font-weight:900;line-height:1}
        .sdesc{font-size:12px;color:var(--muted);margin-top:8px;line-height:1.6}

        /* SECTIONS */
        .sec{max-width:1200px;margin:0 auto;padding:80px 28px}
        .stag{display:inline-flex;align-items:center;gap:6px;background:rgba(193,18,31,.1);border:1px solid rgba(193,18,31,.25);border-radius:50px;padding:6px 16px;font-size:12px;color:#ff6b6b;margin-bottom:16px}
        .sh2{font-size:clamp(28px,3.5vw,42px);font-weight:900;line-height:1.2}
        .sdesc{font-size:15px;color:var(--muted);margin-top:14px;max-width:600px;line-height:1.8}

        /* MONTHS */
        .mgrid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-top:48px}
        .mcard{background:#0a0a0a;border:1px solid var(--border);border-radius:24px;padding:24px;transition:transform .25s,border-color .25s,box-shadow .25s;position:relative;overflow:hidden}
        .mcard::after{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,var(--red),var(--gold));opacity:0;transition:opacity .25s}
        .mcard:hover{transform:translateY(-5px);border-color:rgba(245,166,35,.3);box-shadow:0 20px 50px rgba(0,0,0,.4)}
        .mcard:hover::after{opacity:1}
        .mtop{display:flex;justify-content:space-between;align-items:center;margin-bottom:16px}
        .mnum{font-size:22px;font-weight:900;color:var(--red)}
        .mtag{font-size:11px;color:#ffffff;font-weight:700;background:var(--surface);border:1px solid var(--border);border-radius:8px;padding:4px 10px}
        .mtitle{font-size:20px;font-weight:900}
        .mitems{margin-top:18px;display:flex;flex-direction:column;gap:10px}
        .mitem{display:flex;align-items:flex-start;gap:10px;background:rgba(255,255,255,.03);border-radius:12px;padding:10px 14px;font-size:13px;color:rgba(240,240,240,.8);line-height:1.5}
        .mbullet{width:7px;height:7px;border-radius:50%;background:var(--gold);flex-shrink:0;margin-top:5px}

        /* ABOUT */
        .agrid{display:grid;grid-template-columns:1fr 1fr;gap:20px}
        .acard{background:#0a0a0a;border:1px solid var(--border);border-radius:28px;padding:36px}
        .acard.gb{border-color:rgba(245,166,35,.2);background:linear-gradient(135deg,rgba(245,166,35,.06),rgba(193,18,31,.06))}
        .atag{font-size:11px;color:var(--muted);background:var(--surface);border:1px solid var(--border);border-radius:8px;padding:5px 12px;display:inline-block;margin-bottom:14px}
        .ah2{font-size:28px;font-weight:900}
        .ap{font-size:15px;color:var(--muted);margin-top:16px;line-height:1.9;text-align:justify}
        .olabel{font-size:12px;color:var(--gold);margin-bottom:16px;margin-top:20px;letter-spacing:.5px}
        .olist{display:flex;flex-direction:column;gap:10px}
        .oitem{display:flex;align-items:flex-start;gap:12px;background:rgba(0,0,0,.3);border:1px solid var(--border);border-radius:14px;padding:14px 18px;font-size:14px;color:rgba(240,240,240,.85)}
        .oicon{font-size:16px;flex-shrink:0}

        /* CONTACT */
        .cwrap{max-width:1200px;margin:0 auto;padding:0 28px 100px}
        .cbox{background:#080808;border:1px solid var(--border);border-radius:36px;padding:52px;position:relative;overflow:hidden}
        .cg1{position:absolute;top:-60px;left:-60px;width:300px;height:300px;border-radius:50%;background:radial-gradient(circle,rgba(193,18,31,.18) 0%,transparent 70%);pointer-events:none}
        .cg2{position:absolute;bottom:-60px;right:-60px;width:280px;height:280px;border-radius:50%;background:radial-gradient(circle,rgba(245,166,35,.14) 0%,transparent 70%);pointer-events:none}
        .cinner{display:grid;grid-template-columns:1.1fr .9fr;gap:48px;align-items:start;position:relative}
        .ceyebrow{font-size:12px;color:#2dd4bf;background:rgba(45,212,191,.1);border:1px solid rgba(45,212,191,.35);border-radius:50px;padding:6px 16px;display:inline-block;margin-bottom:18px}
        .ch2{font-size:clamp(26px,3vw,38px);font-weight:900}
        .cp{font-size:15px;color:var(--muted);margin-top:14px;line-height:1.8}
        .fwrap{background:linear-gradient(160deg,rgba(14,165,233,0.08),rgba(168,85,247,0.08),rgba(236,72,153,0.05));border:1px solid rgba(14,165,233,0.35);border-radius:24px;padding:20px;backdrop-filter:blur(10px);margin-top:32px;box-shadow:0 0 40px rgba(14,165,233,0.1),0 0 80px rgba(168,85,247,0.05);position:relative;overflow:hidden}
        .fwrap::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,#0ea5e9,#a855f7,#ec4899)}
        .ftitle{font-size:36px;font-weight:900;margin-bottom:20px;background:linear-gradient(90deg,#0ea5e9,#a855f7,#ec4899);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-align:center}
        .fg{margin-bottom:16px}
        .flabel{display:block;font-size:12px;color:#a5b4fc;margin-bottom:8px;font-weight:600;letter-spacing:.4px}
        .finput{width:100%;background:rgba(255,255,255,.07);border:1px solid rgba(14,165,233,0.25);border-radius:14px;padding:13px 16px;color:var(--text);font-size:14px;font-family:inherit;outline:none;transition:border-color .2s,box-shadow .2s,background .2s}
        .finput:hover{border-color:rgba(74,222,128,.5);background:rgba(34,197,94,.06)}
        .finput:focus{border-color:#22c55e;box-shadow:0 0 0 3px rgba(34,197,94,.15);background:rgba(34,197,94,.06)}
        .rlabel{display:flex;align-items:center;gap:10px;font-size:14px;cursor:pointer;padding:10px 14px;border-radius:12px;transition:background .2s,color .2s;border:1px solid rgba(255,255,255,.06);margin-bottom:6px}
        .rlabel:hover{background:rgba(34,197,94,.12);color:#4ade80;border-color:rgba(34,197,94,.3)}
        .rlabel input{accent-color:var(--red);width:16px;height:16px}
        .sbtn{width:100%;background:linear-gradient(135deg,#0ea5e9,#6366f1);color:#fff;font-weight:800;font-size:15px;padding:15px;border-radius:14px;border:none;cursor:pointer;font-family:inherit;transition:transform .2s,box-shadow .2s,background .3s;box-shadow:0 6px 24px rgba(99,102,241,.4);margin-top:6px}
        .sbtn:hover{transform:translateY(-2px);background:linear-gradient(135deg,#16a34a,#22c55e);box-shadow:0 12px 32px rgba(34,197,94,.5)}
        .icard{background:rgba(0,0,0,.45);border:none;border-radius:24px;padding:20px 20px 0 20px;backdrop-filter:blur(10px)}
        .ititle{font-size:28px;font-weight:900;margin-bottom:18px;background:linear-gradient(90deg,#2dd4bf,#818cf8);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
        .ilink{display:block;background:rgba(255,255,255,.04);border:1px solid var(--border);border-radius:14px;padding:14px 18px;color:rgba(240,240,240,.8);text-decoration:none;font-size:16px;font-weight:700;margin-bottom:12px;transition:background .2s,border-color .2s,color .2s;text-align:right;line-height:1.6;direction:rtl}
        .ilink:first-of-type{border-color:rgba(74,222,128,.3);color:#4ade80}
        .ilink:first-of-type:hover{background:rgba(34,197,94,.1);border-color:rgba(74,222,128,.6)}
        .ilink:last-of-type{border-color:rgba(45,212,191,.3);color:#2dd4bf}
        .ilink:last-of-type:hover{background:rgba(45,212,191,.1);border-color:rgba(45,212,191,.6)}
        .mape{border-radius:0 0 24px 24px;overflow:hidden;margin-top:8px;border:none;outline:none}
        .footer{border-top:1px solid var(--border);text-align:center;padding:28px;font-size:12px;color:var(--muted)}

        @media(max-width:900px){
          .hero{grid-template-columns:1fr;padding:48px 20px 60px;gap:40px}
          .hcard{display:none}
          .mgrid{grid-template-columns:1fr 1fr}
          .agrid,.cinner{grid-template-columns:1fr}
          .sgrid{grid-template-columns:1fr 1fr;gap:12px}
          .cbox{padding:20px 12px;border-radius:20px}
          .cwrap{padding:0 8px 60px}
          .nav-links{display:none}
          .logo-s{display:none}
          .reviews-grid{grid-template-columns:1fr !important}
          .sec{padding:40px 16px}
          .sh2{font-size:clamp(22px,5vw,36px)}
          .h1{font-size:clamp(28px,6vw,48px)}
          .stats-row{margin:30px auto}
          .sgrid{grid-template-columns:1fr 1fr}
        }
        @media(max-width:560px){
          .mgrid{grid-template-columns:1fr}
          .feats{grid-template-columns:1fr}
          .tlist{grid-template-columns:repeat(2,1fr)}
          .cbox{padding:16px 10px;border-radius:16px}
          .cwrap{padding:0 6px 60px}
          .sgrid{grid-template-columns:1fr 1fr;gap:8px}
          .scell{padding:20px 14px}
          .snum{font-size:18px}
          .nav-i{padding:0 16px}
          .logo-b{width:38px;height:38px;font-size:12px}
          .logo-n{font-size:15px}
          .nav-cta{padding:8px 14px;font-size:12px}
          .hero{padding:32px 16px 50px}
          .h1{font-size:clamp(24px,7vw,36px)}
          .hero-p{font-size:14px}
          .sec{padding:30px 12px}
          .reviews-grid{grid-template-columns:1fr !important}
          .acard{padding:24px 16px}
          .ftitle{font-size:24px}
          .fwrap{padding:20px 14px}
          .icard{padding:20px 14px}
        }
      `}</style>

      <div className="page">

        {/* NAV */}
        <nav className="nav">
          <div className="nav-i">
            <div className="logo">
              <div className="logo-b" style={headingStyle}>BA</div>
              <div>
                <div className="logo-n" style={headingStyle}>BIG ACADEMY</div>
                <div className="logo-s">معهد متخصص في التصميم الجرافيكي والمونتاج الفيديو</div>
              </div>
            </div>
            <ul className="nav-links">
              <li><a href="#home">الرئيسية</a></li>
              <li><a href="#program">البرنامج</a></li>
              <li><a href="#about">من نحن</a></li>
              <li><a href="#contact">تواصل معنا</a></li>
            </ul>
            <a href="#contact" className="nav-cta">سجل الآن</a>
          </div>
        </nav>

        {/* HERO */}
        <section id="home" className="hero-wrap">
          <div className="glow-tr" /><div className="glow-bl" />
          <div className="hero">
            <div>
              <div className="eyebrow au d1">الديبلوم المتكامل في التصميم الجرافيكي والمونتاج</div>
              <h1 className="h1 au d2" style={headingStyle}>
                احترف <span className="red">التصميم الجرافيكي</span> و
                <span className="gold"> المونتاج الفيديو</span> من الصفر إلى الاحتراف
              </h1>
              <p className="hero-p au d3">برنامج حضوري 100% لمدة 6 أشهر، يجمع بين تصميم الهوية البصرية، المطبوعات، مونتاج الفيديو، Motion Design، واستعمال تقنيات الذكاء الاصطناعي في الإنتاج الإبداعي.</p>
              <div className="actions au d4">
                <a href="#contact" className="btn-p" style={headingStyle}>سجل الآن — مجانًا</a>
                <a href="#program" className="btn-g" style={headingStyle}>اكتشف البرنامج</a>
              </div>
              <div className="feats au d5">
                {[
                  {text:"برنامج إبداعي 100%",       color:"#63b3ed", border:"rgba(99,179,237,0.35)",  bg:"rgba(99,179,237,0.07)"},
                  {text:"حضوري فقط داخل المعهد",    color:"#68d391", border:"rgba(104,211,145,0.35)", bg:"rgba(104,211,145,0.07)"},
                  {text:"مشاريع حقيقية + Portfolio", color:"#f6ad55", border:"rgba(246,173,85,0.35)",  bg:"rgba(246,173,85,0.07)"},
                  {text:"ديبلوم دولي مهني",          color:"#b794f4", border:"rgba(183,148,246,0.35)", bg:"rgba(183,148,246,0.07)"},
                ].map(f=>(
                  <div key={f.text} className="feat" style={{color:f.color, borderColor:f.border, background:f.bg}}>{f.text}</div>
                ))}
              </div>
            </div>

            {/* HERO CARD */}
            <div className="hcard au d3">
              <div className="ch">
                <div>
                  <div className="cs">Institut Big Academy</div>
                  <div className="ct" style={headingStyle}>إبداعك مهنتك تبدأ من هنا</div>
                </div>
                <div className="cbadge" style={headingStyle}>6 أشهر</div>
              </div>
              <div className="cstats">
                <div className="sb r"><div className="sn" style={headingStyle}>+12</div><div className="sl">أدوات احترافية ستتقنها</div></div>
                <div className="sb g"><div className="sn" style={headingStyle}>100%</div><div className="sl">تدريب عملي وإبداعي</div></div>
              </div>
              <div className="tgrid">
                <div className="tl">الأدوات الأساسية في البرنامج</div>
                <div className="tlist">{tools.map(t=><div key={t} className="tchip">{t}</div>)}</div>
              </div>
            </div>
          </div>
        </section>

        {/* TICKER */}
        <div className="ticker">
          <div className="ttrack">
            {[...Array(2)].map((_,ri)=>
              ["التصميم الجرافيكي","مونتاج الفيديو","Photoshop","Illustrator","Premiere Pro","After Effects","Motion Design","Logo Design","Hوية بصرية","ديبلوم دولي","6 أشهر حضورية","Freelance"].map((item,i)=>(
                <span key={`${ri}-${i}`} className="titem"><span className="tdot"/>{item}</span>
              ))
            )}
          </div>
        </div>

        {/* STATS */}
        <div className="stats-row">
          <div className="sgrid">
            {[
              {title:"6 أشهر",         desc:"برنامج متكامل من البداية إلى الاحتراف", icon:"🗓️", color:"#63b3ed", border:"rgba(99,179,237,0.4)",  bg:"rgba(99,179,237,0.07)"},
              {title:"حضوري 100%",     desc:"التكوين يتم داخل المعهد فقط",           icon:"🎨", color:"#68d391", border:"rgba(104,211,145,0.4)", bg:"rgba(104,211,145,0.07)"},
              {title:"Portfolio حقيقي", desc:"مشاريع إبداعية خلال التكوين",           icon:"🚀", color:"#f6ad55", border:"rgba(246,173,85,0.4)",  bg:"rgba(246,173,85,0.07)"},
              {title:"دعم مباشر",      desc:"مواكبة مستمرة مع الطلبة",               icon:"🤝", color:"#b794f4", border:"rgba(183,148,246,0.4)", bg:"rgba(183,148,246,0.07)"},
            ].map(({title,desc,icon,color,border,bg})=>(
              <div key={title} className="scell" style={{borderColor:border,background:`linear-gradient(160deg,${bg},#0a0a0a 70%)`}}>
                <div className="scell-icon">{icon}</div>
                <div className="snum" style={{...headingStyle,color}}>{title}</div>
                <div className="sdesc">{desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* PROGRAM */}
        <section id="program" className="sec">
          <div className="stag">◆ برنامج التكوين</div>
          <h2 className="sh2" style={headingStyle}>برنامج إبداعي مصمم على 6 أشهر</h2>
          <p className="sdesc">كل محور له أهداف واضحة، مهارات محددة، وتطبيقات عملية تساعد الطالب على الانتقال التدريجي من التعلم إلى الإنتاج الاحترافي.</p>
          <div className="mgrid">
            {months.map((month,i)=>{
              const colors=[
                {border:'rgba(99,179,237,0.45)',bg:'rgba(99,179,237,0.07)',num:'#63b3ed',bullet:'#63b3ed'},
                {border:'rgba(154,230,180,0.45)',bg:'rgba(154,230,180,0.07)',num:'#68d391',bullet:'#68d391'},
                {border:'rgba(251,211,141,0.45)',bg:'rgba(251,211,141,0.07)',num:'#f6ad55',bullet:'#f6ad55'},
                {border:'rgba(252,129,129,0.5)', bg:'rgba(252,129,129,0.07)',num:'#fc8181',bullet:'#fc8181'},
                {border:'rgba(183,148,246,0.45)',bg:'rgba(183,148,246,0.07)',num:'#b794f4',bullet:'#b794f4'},
                {border:'rgba(246,173,85,0.5)',  bg:'rgba(246,173,85,0.07)', num:'#f6ad55',bullet:'#ecc94b'},
              ];
              const c=colors[i];
              return(
                <div key={month.title} className="mcard" style={{borderColor:c.border,background:`linear-gradient(160deg,${c.bg},#0a0a0a 60%)`}}>
                  <div className="mtop"><span className="mnum" style={{color:c.num}}>0{i+1}</span><span className="mtag">{month.title}</span></div>
                  <div className="mtitle" style={{...headingStyle, color:c.num}}>{month.subtitle}</div>
                  <div className="mitems">
                    {month.items.map(item=>(
                      <div key={item} className="mitem"><span className="mbullet" style={{background:c.bullet}}/><span>{item}</span></div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        {/* ABOUT */}
        <section id="about" className="sec" style={{paddingTop:0}}>
          <div className="agrid">
            <div className="acard" style={{borderColor:'rgba(99,179,237,0.45)',background:'linear-gradient(160deg,rgba(99,179,237,0.07),#0a0a0a 60%)'}}>
              <div className="atag" style={{color:'#63b3ed'}}>من نحن</div>
              <h2 className="ah2" style={headingStyle}>Big Academy</h2>
              <p className="ap">معهد متخصص في التكوين في مجال التصميم الجرافيكي والمونتاج الفيديو، يقدّم برامج تدريبية متكاملة تعتمد على التطبيق الإبداعي العملي والمعرفة الحديثة، بهدف تأهيل المتدربين لدخول سوق الإنتاج الرقمي بكفاءة وثقة.</p>
              <p className="ap">نحن لا نقدّم مجرد دورات تدريبية، بل نصنع تجربة إبداعية متكاملة تمكّن المتدرب من بناء هويته المهنية خطوة بخطوة، واكتساب مهارات حقيقية مطلوبة في سوق الإنتاج المرئي وعالم التصميم.</p>
              <p className="ap">Big Academy هي انطلاقتك الحقيقية نحو الاحتراف في عالم الإبداع الرقمي 🎨</p>
            </div>
            <div className="acard gb" style={{borderColor:'rgba(246,173,85,0.45)',background:'linear-gradient(160deg,rgba(246,173,85,0.08),rgba(193,18,31,0.06) 60%)'}}>
              <div className="atag" style={{color:'var(--gold)'}}>النتيجة النهائية</div>
              <h2 className="ah2" style={headingStyle}>ماذا سيحقق الطالب بعد 6 أشهر؟</h2>
              <div className="olabel">المخرجات المهنية</div>
              <div className="olist">
                {[
                  ["🎨","إتقان Adobe Illustrator واحتراف التصميم الفيكتوري","rgba(99,179,237,0.15)","rgba(99,179,237,0.4)"],
                  ["🖼️","معالجة الصور احترافيًا مع Photoshop و Lightroom","rgba(154,230,180,0.15)","rgba(154,230,180,0.4)"],
                  ["🎬","مونتاج فيديو احترافي جاهز للنشر","rgba(251,211,141,0.15)","rgba(251,211,141,0.4)"],
                  ["🏢","تصميم هويات بصرية ومطبوعات احترافية مع InDesign","rgba(252,129,129,0.15)","rgba(252,129,129,0.4)"],
                  ["💼","العمل الحر (Freelance) وإدارة العلاقة مع العملاء","rgba(183,148,246,0.15)","rgba(183,148,246,0.4)"],
                  ["🎓","الحصول على ديبلوم دولي مهني معتمد","rgba(246,173,85,0.15)","rgba(246,173,85,0.4)"],
                ].map(([icon,text,bg,border])=>(
                  <div key={text} className="oitem" style={{background:bg,borderColor:border}}><span className="oicon">{icon}</span><span>{text}</span></div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* PRICING */}
        <section className="sec" style={{paddingTop:0,paddingBottom:'60px'}}>
          <div className="stag">💰 رسوم التكوين</div>
          <h2 className="sh2" style={headingStyle}>استثمر في موهبتك الإبداعية</h2>
          <div style={{display:'flex',flexDirection:'column',gap:'16px',marginTop:'40px',maxWidth:'800px',margin:'40px auto 0'}}>

            <div style={{background:'linear-gradient(135deg,rgba(99,179,237,0.1),#0a0a0a 80%)',border:'1px solid rgba(99,179,237,0.4)',borderRadius:'20px',padding:'20px 24px',display:'flex',flexWrap:'wrap',alignItems:'center',justifyContent:'space-between',gap:'12px',position:'relative',overflow:'hidden'}}>
              <div style={{position:'absolute',top:0,bottom:0,right:0,width:'4px',background:'linear-gradient(180deg,#63b3ed,#2dd4bf)'}}/>
              <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
                <span style={{fontSize:'28px'}}>📋</span>
                <div style={{fontFamily:"'Tajawal',sans-serif",fontSize:'16px',fontWeight:800,color:'#fff'}}>رسوم التسجيل</div>
              </div>
              <div style={{display:'flex',alignItems:'baseline',gap:'6px'}}>
                <span style={{fontFamily:"'Tajawal',sans-serif",fontSize:'40px',fontWeight:900,color:'#63b3ed',lineHeight:1}}>100</span>
                <span style={{color:'#63b3ed',fontWeight:700,fontSize:'18px'}}>درهم</span>
              </div>
              <div style={{color:'rgba(255,255,255,.45)',fontSize:'12px',textAlign:'right',width:'100%'}}>تُدفع مرة واحدة عند الالتحاق</div>
            </div>

            <div style={{background:'linear-gradient(135deg,rgba(246,173,85,0.1),#0a0a0a 80%)',border:'1px solid rgba(246,173,85,0.4)',borderRadius:'20px',padding:'20px 24px',display:'flex',flexWrap:'wrap',alignItems:'center',justifyContent:'space-between',gap:'12px',position:'relative',overflow:'hidden'}}>
              <div style={{position:'absolute',top:0,bottom:0,right:0,width:'4px',background:'linear-gradient(180deg,#f6ad55,#ecc94b)'}}/>
              <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
                <span style={{fontSize:'28px'}}>🎓</span>
                <div style={{fontFamily:"'Tajawal',sans-serif",fontSize:'16px',fontWeight:800,color:'#fff'}}>رسوم التكوين</div>
              </div>
              <div style={{display:'flex',alignItems:'baseline',gap:'6px'}}>
                <span style={{fontFamily:"'Tajawal',sans-serif",fontSize:'40px',fontWeight:900,color:'#f6ad55',lineHeight:1}}>400</span>
                <span style={{color:'#f6ad55',fontWeight:700,fontSize:'18px'}}>درهم / شهر</span>
              </div>
              <div style={{color:'rgba(255,255,255,.45)',fontSize:'12px',textAlign:'right',width:'100%'}}>لمدة 6 أشهر كاملة</div>
            </div>

          </div>
        </section>

        {/* TESTIMONIALS */}
        <section className="sec" style={{paddingTop:0,paddingBottom:'60px'}}>
          <div className="stag">⭐ قصص النجاح</div>
          <h2 className="sh2" style={headingStyle}>طلابنا يتحدثون عنا</h2>
          <div className="reviews-grid" style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'20px',marginTop:'40px'}}>
            {[
              {
                name:'سارة م.',
                role:'طالبة سابقة — مصممة جرافيكية',
                avatar:'س',
                color:'#63b3ed',
                border:'rgba(99,179,237,0.4)',
                bg:'rgba(99,179,237,0.07)',
                text:'💬 "بدأت من الصفر في التصميم، واليوم عندي عملاء حقيقيين وأشتغل Freelance بشكل كامل."'
              },
              {
                name:'يوسف ك.',
                role:'طالب سابق — مونتير فيديو',
                avatar:'ي',
                color:'#f6ad55',
                border:'rgba(246,173,85,0.4)',
                bg:'rgba(246,173,85,0.07)',
                text:'💬 "أكثر شيء عجبني هو المشاريع الحقيقية، خرجت بـ Portfolio كامل يتكلم عني أمام أي عميل."'
              },
              {
                name:'نور الدين ع.',
                role:'طالب سابق — Motion Designer',
                avatar:'ن',
                color:'#b794f4',
                border:'rgba(183,148,246,0.4)',
                bg:'rgba(183,148,246,0.07)',
                text:'💬 "تعلمت After Effects من الصفر وأصبحت أصنع Intros احترافية لشركات حقيقية بأكادير."'
              },
            ].map((t)=>(
              <div key={t.name} style={{background:`linear-gradient(160deg,${t.bg},#0a0a0a 70%)`,border:`1px solid ${t.border}`,borderRadius:'24px',padding:'28px',position:'relative',overflow:'hidden',display:'flex',flexDirection:'column',gap:'16px'}}>
                <div style={{position:'absolute',top:0,left:0,right:0,height:'3px',background:`linear-gradient(90deg,${t.color},transparent)`}}/>
                <div style={{color:'#f6ad55',fontSize:'16px',letterSpacing:'2px'}}>★★★★★</div>
                <div style={{fontSize:'28px',color:t.color,lineHeight:1,fontFamily:'Georgia,serif'}}>"</div>
                <p style={{fontSize:'14px',color:'rgba(255,255,255,.8)',lineHeight:'1.8',marginTop:'-12px',flex:1}}>{t.text}</p>
                <div style={{display:'flex',alignItems:'center',gap:'12px',borderTop:`1px solid ${t.border}`,paddingTop:'16px'}}>
                  <div style={{width:'42px',height:'42px',borderRadius:'50%',background:`linear-gradient(135deg,${t.color},${t.border})`,display:'flex',alignItems:'center',justifyContent:'center',fontFamily:"'Tajawal',sans-serif",fontWeight:900,fontSize:'16px',color:'#000',flexShrink:0}}>
                    {t.avatar}
                  </div>
                  <div>
                    <div style={{fontFamily:"'Tajawal',sans-serif",fontWeight:800,fontSize:'15px',color:'#fff'}}>{t.name}</div>
                    <div style={{fontSize:'12px',color:t.color,marginTop:'2px'}}>{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CONTACT */}
        <div id="contact" className="cwrap">
          <div className="cbox">
            <div className="cg1"/><div className="cg2"/>
            <div className="cinner">
              <div>
                <div className="ceyebrow">التسجيل مفتوح الآن</div>
                <h2 className="ch2" style={headingStyle}>ابدأ رحلتك الإبداعية مع Big Academy</h2>
                <p className="cp">انضم إلى برنامج احترافي يساعدك على تعلم مهارات الإبداع الرقمي، بناء Portfolio احترافي، وتطوير فرصك في عالم التصميم والإنتاج المرئي.</p>
                <div className="fwrap">
                  <div className="ftitle" style={headingStyle}>طلب التسجيل</div>
                  <form onSubmit={handleLeadSubmit}>
                    <div className="fg"><label className="flabel">Nom Complet</label><input name="fullName" type="text" placeholder="أدخل اسمك الكامل" className="finput" style={bodyStyle}/></div>
                    <div className="fg"><label className="flabel">Numéro de téléphone</label><input name="phone" type="tel" placeholder="06 06 16 16 63" className="finput" style={bodyStyle}/></div>
                    <div className="fg">
                      <label className="flabel">طريقة التواصل المفضلة</label>
                      <div className="rgroup">
                        <label className="rlabel"><input type="radio" name="contactMethod" value="إتصال هاتفي"/>إتصال هاتفي</label>
                        <label className="rlabel"><input type="radio" name="contactMethod" value="عبر واتساب"/>عبر واتساب</label>
                      </div>
                    </div>
                    <button type="submit" className="sbtn" style={headingStyle}>إرسال الطلب</button>
                    {submitMsg && <div style={{marginTop:'12px',padding:'12px',borderRadius:'12px',background:'rgba(34,197,94,.15)',border:'1px solid rgba(34,197,94,.4)',color:'#4ade80',textAlign:'center',fontSize:'14px'}}>{submitMsg}</div>}
                  </form>
                </div>
              </div>
              <div>
                <div className="icard">
                  <div className="ititle" style={headingStyle}>معلومات التواصل</div>
                  <a href="https://wa.me/212606161663" target="_blank" rel="noreferrer" className="ilink" style={{justifyContent:'flex-end',direction:'rtl'}}>📱 واتساب: 0606161663</a>
                  <a href="https://www.google.com/maps/search/?api=1&query=مدينة+أكادير+حي+السلام+زنقة+المعدر+إقامة+باب+السلام+الطابق+الأول+أمام+صيدلية+السلام" target="_blank" rel="noreferrer" className="ilink">
                    📍 مدينة أكادير، حي السلام، زنقة المعدر، إقامة باب السلام، الطابق الأول — أمام صيدلية السلام
                  </a>
                  <div className="mape">
                    <iframe title="Big Academy Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d860.2966526962449!2d-9.549635455163388!3d30.402446940180177!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xdb3b7fc236e62eb%3A0xcdcf9245b36ea9fe!2sBig%20Academy%20-%20Centre%20de%20Formation%20%C3%A0%20Agadir!5e0!3m2!1sfr!2sma!4v1773869274878!5m2!1sfr!2sma" width="100%" height="300" style={{border:0,display:'block'}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="footer">
          © {new Date().getFullYear()} BIG ACADEMY — جميع الحقوق محفوظة
        </footer>

        {/* SCROLL TO TOP */}
        {showScroll && (
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            style={{
              position:'fixed', bottom:'28px', left:'28px', zIndex:999,
              width:'48px', height:'48px', borderRadius:'50%',
              background:'linear-gradient(135deg,#f59e0b,#ef4444)',
              border:'none', cursor:'pointer',
              display:'flex', alignItems:'center', justifyContent:'center',
              boxShadow:'0 6px 24px rgba(245,158,11,.5)',
              transition:'transform .2s, box-shadow .2s',
              fontSize:'22px',
            }}
            onMouseEnter={e => {e.currentTarget.style.transform='translateY(-4px)';e.currentTarget.style.boxShadow='0 12px 32px rgba(245,158,11,.7)'}}
            onMouseLeave={e => {e.currentTarget.style.transform='translateY(0)';e.currentTarget.style.boxShadow='0 6px 24px rgba(245,158,11,.5)'}}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="18 15 12 9 6 15"/>
            </svg>
          </button>
        )}

      </div>
    </>
  );
}
